import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Swiper from 'react-id-swiper';
import 'swiper/css/swiper.css';

import useEvent from '../Hooks/useEvent';
import * as PATH from '../lib/routes/path';
import { MainCarouselPc } from '../lib/image/HomeImages';
import { Anchor } from './common/atom/Anchor';

const LinkImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  cursor: pointer;
`;

const HomeCarousel = () => {
  const { eventHomeBannerList } = useEvent();

  const isSlideMoreThanOne =
    eventHomeBannerList.concat(MainCarouselPc).length > 1;

  const params = {
    loop: isSlideMoreThanOne,
    autoplay: isSlideMoreThanOne && {
      delay: 2500,
      disableOnInteraction: false,
    },
    allowTouchMove: isSlideMoreThanOne,
  };

  return (
    <Swiper {...params}>
      {eventHomeBannerList.map((banner) => {
        const {
          id,
          image: { alt, src },
          url,
          path,
        } = banner;
        return (
          url ? (
            <Anchor href={url} key={id}>
              <LinkImage src={src} alt={alt} />
            </Anchor>
          ) : path ? (
            <Link to={path} key={id}>
              <LinkImage src={src} alt={alt} />
            </Link>
          ) : (
            <Link to={`${PATH.EVENT_DETAIL}/${id}`} key={id}>
              <LinkImage src={src} alt={alt} />
            </Link>
          )
        );
      })}
      {MainCarouselPc.map((imgSrc, idx) => (
        <img
          key={idx}
          src={imgSrc}
          alt="home_banner_img"
          width="100%"
          height="100%"
        />
      ))}
    </Swiper>
  );
};

export default HomeCarousel;
